import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowTriangleLeft"><Path d="M19.9998 3.53711V20.4642L3.07275 12.0006L19.9998 3.53711Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleLeft;
